import React from 'react';
import LiveNavbar from './LiveNavbar';
import { Container } from 'react-bootstrap';
import TopNav from '../nav/TopNav';
import MainFooter from '../nav/MainFooter';
import LiveExpBanner from './LiveExpBanner';
import LiveEvents from './LiveEvents';

const LiveThrowdown = () => {
  return (
    <Container className='LiveThrowdown p-0' fluid>
      <TopNav />
      <LiveNavbar />
      <Container fluid className='LiveThrowdown_banner px-0'>
        <LiveExpBanner />
        <LiveEvents />
        <MainFooter />
      </Container>
    </Container>
  );
};
export default LiveThrowdown;
